import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  CardContainer: {
    padding: '10px !important',
  },
  cardHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    gap: '10px !important',
  },
  avatar: {
    width: '48px !important',
    height: '48px !important',
    color: theme.palette.KenColors.ClientBlue7,
    backgroundColor: theme.palette.KenColors.WhiteGray4,
  },
  cardHeaderTitleContainer: { display: 'flex', flexDirection: 'column', alignItems: 'start' },
  cardHeaderTitle: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    lineHeight: '22px !important',
    color: '#373A45',
  },
  cardHeaderLocation: {
    fontSize: '10.5px !important',
    fontWeight: '400 !important',
    lineHeight: '19px !important',
    color: '#373A45',
  },
  cardContent: {
    marginBlock: '20px !important',
  },
  detailBodyText: {
    textAlign: 'start',
    fontSize: '12px !important',
    fontWeight: '400 !important',
    marginBottom: '12px !important',
    lineHeight: '22px !important',
  },
  bodyText: {
    textAlign: 'start',
    fontSize: '12px !important',
    fontWeight: '400 !important',
    color: '#585A64',
    lineHeight: '22px !important',
  },
  hashtagText: {
    textAlign: 'start',
    marginTop: '20px !important',
    fontSize: '12px !important',
    fontWeight: '400 !important',
    lineHeight: '22px !important',
    color: '#585A64',
  },
  cardActions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    marginBlock: '20px',
  },
  button: {
    fontSize: '16px !important',
    fontWeight: '400 !important',
    lineHeight: '22px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
    },
  },
  GroupCard: {
    height: '100%',
    borderRadius: '12px !important',
    textAlign: 'start',
    width: '100%',
    position: 'relative',
    backgroundColor: '#F6F8FB',
    backgroundSize: 'cover !important',
    backgroundPosition: 'center !important',
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeader: {
    color: theme.palette.KenColors.ClientBlack2,
    fontSize: '20px !important',
    fontWeight: '500 !important',
    textTransform: 'capitalize',
    margin: '0px 30px 0px 4px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '18px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px !important',
    },
  },
  cardAvatarGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
  },
  cardActionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '0px',
    margin: '10px auto',
  },
  cardActionContainerTypo: {
    color: theme.palette.KenColors.ClientBlack,
    fontSize: '10.5px !important',
    fontWeight: '400 !important',
    marginLeft: '4px !important',
  },
  classSixteen: {
    color: theme.palette.KenColors.ClientBlack2,
    fontSize: '12px !important',
    fontWeight: '500 !important',
    textTransform: 'capitalize',
    margin: '0px 30px 0px 4px !important',
  },
}));
